import {linearToSrgb, srgbToLinear} from "@cm/image-processing/operations/tone-mapping"
import {colorToString} from "@cm/utils"
import {stringToColor} from "@cm/utils/misc"

export function srgbHexToLinearColor(hex: string): [number, number, number] {
    const [r, g, b] = stringToColor(hex)
    return [srgbToLinear(r), srgbToLinear(g), srgbToLinear(b)]
}

export function linearColorToSrgbHex(color: [number, number, number]): string {
    return colorToString([linearToSrgb(color[0]), linearToSrgb(color[1]), linearToSrgb(color[2])])
}
